var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

$(document).ready(function(){
  $('#pt').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  $('#bt').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  $('#rt').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  $('#bet').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });

  $('#rg').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  $('#rs').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  $('#rb').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });

  $('#wb').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  $('#wc').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  $('#wl').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  $('#wba').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });

  $('#sd').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  $('#md').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
    
  $('#ss').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  $('#sm').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });
  
  $('#wts').on('click', function(){
      $(this).addClass('btncolor').siblings().removeClass('btncolor');
  });

  $('header-menu details').on('mouseenter',function(){
      $('header-menu details').removeAttr('open');
        $('header-menu details .header__menu-item').removeAttr('aria-expanded');
        $(this).attr('open', true).find('.header__menu-item').attr('aria-expanded',true);
  });
  $('header-menu details').on('mouseleave',function(){		 
        $(this).attr('open', false).find('.header__menu-item').removeAttr('aria-expanded');
  });

  // $(document).on('click','.image-bullet-points ul.tab-color-bullets li', function(){
  //   var currentId = $(this).parents('.custom-image-with-text').attr('id');
  //   $('#' + currentId + ' .image-bullet-points ul.tab-color-bullets li').removeClass('active');
  //   $('#' + currentId + ' .custom-image-item .tab-image-block .tab-image-item').removeClass('active');
  //   var current_value = $(this).data('index');
  //   $(this).addClass('active');
  //   $('#' + currentId + ' .custom-image-item .tab-image-block .tab-image-item[tab-image="'+current_value+'"]').addClass('active');
  // });

  $('.main-carousel').flickity({
  cellAlign: 'left',
  contain: true
  });

  //   $( function() {
  //   var $gallery = $('.fade-slider');
  //   $gallery.removeClass('is-hidden');
  //   $gallery.flickity({
  //   cellAlign: 'center',
  //   fade: true,
  //   draggable: false,
  //   freeScroll: false,
  //   imagesLoaded: true,
  //   pageDots: false,
  //   prevNextButtons: false,
  //   wrapAround: true,
  //   autoPlay: true,
  //   autoPlay: 2000,
  //   pauseAutoPlayOnHover: false
  //   });
  
  //   var flickity = $gallery.data('flickity');
  //   var $galleryNav = $('.fade-slider-bullet');
  //   var $galleryNavItems = $galleryNav.find('li');
  //   $gallery.on( 'change.flickity', function(event, index) {
  //     console.log($(this).closest('.custom-image-item'));
  //     $(this).closest('.custom-image-item').find('.fade-slider-bullet .is-selected').removeClass('is-selected');
  //     $(this).closest('.custom-image-item').find('.fade-slider-bullet li').eq( flickity.selectedIndex ).addClass('is-selected');
  //   });
    
  //   // $galleryNav.on( 'click', 'li', function() {
  //   //   var index = $(this).index();
  //   //   $gallery.flickity( 'select', index );
  //   // });
    
  // });
  $('.fade-slider').each(function(i, container) {

    var options = {
    cellAlign: 'center',
    fade: true,
    draggable: false,
    freeScroll: false,
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    autoPlay: 2000,
    pauseAutoPlayOnHover: false,
    resize: true,
    adaptiveHeight: true
  };
    $(this).removeClass('is-hidden');
    $slider = $(this).flickity(options);
    var flickity = $slider.data('flickity');

    $slider.on( 'select.flickity', function( event, index ) {
      flickity.options.draggable = !1;
      flickity.updateDraggable();
      $(event.currentTarget).next('.fade-slider-bullet').find('li').removeClass('is-selected');
      $(event.currentTarget).next('.fade-slider-bullet').find('li').eq( index ).addClass('is-selected');
    });
    $slider.on( 'dragMove.flickity', function( event, pointer, moveVector ) {
      var tab_val = $(pointer.path[1]).attr('tab-image');
       $(event.currentTarget).next('.fade-slider-bullet').find('li').removeClass('is-selected');
       $(event.currentTarget).next('.fade-slider-bullet').find('li[data-tab_val="'+tab_val+'"]').addClass('is-selected');
    });

  });

    $('.fade-slider-bullet').on( 'click', 'li', function() {
      var index = $(this).index();
      $(this).closest('.custom-image-item').find('.fade-slider').flickity( 'select', index );
    });
  
    $(document).on('click','.image_size',function(e){
      e.preventDefault();
      $(this).closest('.popup_image').find('.popup-overlay').fadeIn('slow');
    }); 
  $('.pop-close').click(function(){
    $('.popup-overlay').fadeOut('slow');
  });
  $(document).on('click','.popup-overlay',function(){
    $(this).fadeOut('slow'); 
  });
  $( document ).on( 'keydown', function ( e ) {
    if (e.keyCode === 27) { 
      $('.popup-overlay').fadeOut('slow');
    }
  });
  $(document).on('click','.popup-body',function(e){
    e.preventDefault();
    e.stopPropagation();
  });

  $(window).on('orientationchange', function(event) {    
    if($(window).width() >= 750 || $(window).width() <= 1300){
      $('.fade-slider').each(function(i, container) {
      var options = {
        cellAlign: 'center',
        fade: true,
        draggable: false,
        freeScroll: false,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: 2000,
        pauseAutoPlayOnHover: false,
        resize: true,
        adaptiveHeight: true
      };
        $(this).removeClass('is-hidden');
        $slider = $(this).flickity(options);
        var flickity = $slider.data('flickity');
    
        $slider.on( 'select.flickity', function( event, index ) {
          flickity.options.draggable = !1;
          flickity.updateDraggable();
          $(event.currentTarget).next('.fade-slider-bullet').find('li').removeClass('is-selected');
          $(event.currentTarget).next('.fade-slider-bullet').find('li').eq( index ).addClass('is-selected');
        });
        $slider.on( 'dragMove.flickity', function( event, pointer, moveVector ) {
          var tab_val = $(pointer.path[1]).attr('tab-image');
           $(event.currentTarget).next('.fade-slider-bullet').find('li').removeClass('is-selected');
           $(event.currentTarget).next('.fade-slider-bullet').find('li[data-tab_val="'+tab_val+'"]').addClass('is-selected');
        });
    
      });
    }
  });

  var is_news_success = getUrlParameter('customer_posted');
  if(is_news_success){
    $('.overlay, .success_newsletter').show();
  }
  $('.success_newsletter a').click(function() {
    $('.overlay, .success_newsletter').hide();
  });
});

window.addEventListener( "pageshow", function ( event ) {
var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
if ( historyTraversal ) {
window.location.reload();
}
});

$("body").on('click touchstart', 'a.alt-anchr', function(e) {
e.preventDefault();
window.location.href = $(this).attr('data-url');
return false;
});

